import { render, staticRenderFns } from "./service-radio-group.vue?vue&type=template&id=1a928326"
import script from "./service-radio-group.vue?vue&type=script&lang=js"
export * from "./service-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports